import React, { useState } from 'react';
import { Card } from './Card';
import { Heading } from './Typography';
import Button from './Button';
import { ClubSectionIcon, MANAGEMENT_ICON_TONES } from '../clubs/dashboard/ClubSectionIcons';

const CollapsibleSection = ({ 
  title, 
  icon, 
  iconType,
  children, 
  defaultExpanded = false,
  expanded: controlledExpanded,
  onExpandedChange,
  className = "",
  variant = "default"
}) => {
  const [internalExpanded, setInternalExpanded] = useState(defaultExpanded);
  const isExpanded = controlledExpanded !== undefined ? controlledExpanded : internalExpanded;
  const iconTone = iconType ? MANAGEMENT_ICON_TONES[iconType] : null;

  const setExpanded = (next) => {
    if (controlledExpanded === undefined) {
      setInternalExpanded(next);
    }
    onExpandedChange?.(next);
  };

  const renderSectionIcon = () => {
    if (!iconType && !icon) return null;

    return (
      <div
        className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-border-medium shadow-brand-sm ${
          iconTone?.well ?? 'bg-surface'
        }`}
      >
        {iconType ? (
          <span className={iconTone?.text ?? 'text-text-secondary'}>
            <ClubSectionIcon type={iconType} className="h-4 w-4" />
          </span>
        ) : (
          icon
        )}
      </div>
    );
  };

  return (
    <Card variant={variant} size="medium" className={`overflow-visible p-0 ${className}`}>
      <div
        className="cursor-pointer border-b border-border-medium bg-surface-subtle px-4 py-3 transition-colors hover:bg-surface-elevated sm:px-6 sm:py-4"
        onClick={() => setExpanded(!isExpanded)}
      >
        <div className="flex items-center justify-between gap-3">
          <div className="flex min-w-0 items-center gap-3">
            {renderSectionIcon()}
            <Heading level={2} className="mb-0 truncate text-base font-semibold text-text-primary sm:text-lg">
              {title}
            </Heading>
          </div>
          <Button
            variant="ghost"
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              setExpanded(!isExpanded);
            }}
            className="text-text-secondary hover:text-text-primary"
          >
            <svg 
              className={`w-5 h-5 transition-transform duration-200 ${isExpanded ? 'rotate-180' : ''}`} 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
            </svg>
          </Button>
        </div>
      </div>

      {/* Section Content */}
      {isExpanded ? (
        <div className="border-t border-border-medium p-4 sm:p-6">{children}</div>
      ) : null}
    </Card>
  );
};

export default CollapsibleSection;
